import { Col, Row } from 'antd'
import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import employeeImage from '../assets/images/login-employee.png'
import { ReactComponent as Logo } from '../assets/images/logo.svg'
import AddToHomeScreenBanner from '../atoms/AddToHomeBanner'
import { useLanguageContext } from '../contexts/LanguageContext'
import { getLocalizedUrls } from '../utils/languageUtils'

const AuthLayout: FC<PropsWithChildren> = ({ children }) => {
	const { t } = useTranslation()
	const { currentLanguage } = useLanguageContext()
	const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 858)

	const { privacyUrl } = getLocalizedUrls(currentLanguage)
	useEffect(() => {
		const handleResize = () => {
			setIsSmallScreen(window.innerWidth <= 858)
		}
		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])
	return (
		<section className={'h-100% bg-gradient-to-tl from-purple-base to-pink'}>
			<Row align={'middle'} className={'h-100%'}>
				<Col xs={{ span: 0 }} lg={{ span: 7 }} xl={{ span: 8 }} className={'h-100% relative'}>
					<img
						src={employeeImage}
						alt={''}
						className={'absolute z-1 top-50% right-0 transform -translate-y-50% translate-x-50% origin-left scale-90% xl:scale-100%'}
						style={{ minWidth: '430px', maxWidth: '430px' }}
					/>
				</Col>
				<Col xs={{ span: 24 }} lg={{ span: 17 }} xl={{ span: 16 }} className={'h-100% relative flex justify-center bg-white lg:rounded-l-xl'}>
					<div className={'w-100% lg:w-auto my-7 lg:my-[16vh] mx-4 lg:mx-0 transform lg:translate-x-25%'}>
						<div className={'text-center mb-12'}>
							<Logo className={'mx-auto h-16 md:h-20'} />
						</div>
						<div className={'w-100% max-w-[40rem] lg:w-[21.5rem] mx-auto flex flex-col'}>{children}</div>
					</div>
					<a
						href={privacyUrl}
						className={'absolute bottom-4 right-4 text-13 text-gradient'}
						target={'_blank'}
						rel={'noopener noreferrer'}
						style={{
							position: isSmallScreen ? 'fixed' : 'absolute',
							zIndex: 3,
							right: isSmallScreen ? '0.3rem' : '4rem'
						}}
					>
						{t('loc:general|Privacy policy')}
					</a>
				</Col>
			</Row>

			<span
				style={{
					position: 'absolute',
					bottom: '2rem',
					transform: isSmallScreen ? 'none' : 'translateX(-15%)',
					width: '100%',
					zIndex: 1
				}}
			>
				<AddToHomeScreenBanner />
			</span>
		</section>
	)
}

export default AuthLayout
